module.exports = __webpack_public_path__ + "img/Driftmier_-_BN_-_t-24706-079.a741774a.jpg";